import { render, staticRenderFns } from "./homeNew.vue?vue&type=template&id=3c4a6d9e"
import script from "./homeNew.vue?vue&type=script&lang=js"
export * from "./homeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports